import React, { useMemo, useState } from "react";
import { MaterialReactTable } from "material-react-table";
import {
  Box,
  Button,
  Container,
  Grid,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import { AppBarComponent } from "../Components/AppBar";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import {
  addEspaceCharacters,
  deleteTableDots,
  instance,
} from "../Components/config";
import { DialogAlert } from "../Components/DialogAlert";
import { useAuth } from "../Components/AuthContext";
import { LoaderBox } from "../Components/LoaderBox";

function RolAgregar() {
  const [isLoading, setLoading] = useState(true);
  const [items, setItems] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [dialog, setDialog] = useState({
    title: "",
    text: "",
  });
  const [nombre, setNombre] = useState("");
  const [funciones, setFunciones] = useState([]);
  deleteTableDots(1);
  const { user } = useAuth();

  const columns = useMemo(() => [
    {
      accessorKey: "id",
      header: "ID",
    },
    {
      accessorKey: "nombre",
      header: "Nombre",
    },
    {
      accessorFn: (row) => `${row.id}${row.nombre}`,
      id: "edit",
      header: "",
      size: 10,
      enableColumnFilter: false,
      Cell: ({ renderedCellValue, row }) => (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "1rem",
          }}
        >
          <Button>
            <Switch onChange={() => addFuncion(row.original.id)} />
          </Button>
        </Box>
      ),
    },
  ]);
  const addFuncion = (id) => {
    const index = funciones.findIndex((item) => {
      return item.id === id;
    });
    funciones[index].estado = Number(!funciones[index].estado);
  };

  async function populateTable() {
    try {
      const { data } = await instance.get("/rol/funciones");
      setItems(data);
      setFunciones(
        data.map((item) => {
          return { id: item.id, nombre: item.nombre, estado: 0 };
        })
      );
    } catch (error) {
      alert(error);
    }
  }
  if (isLoading) {
    populateTable();
    setLoading(false);
  }
  const handleSubmit = (e) => {
    e.preventDefault();
    const info = e.target;
    instance
      .post("/rol/", {
        id: user.id,
        nombre: addEspaceCharacters(info.nombre.value),
        funciones: funciones
          .filter((item) => {
            return item.estado === 1;
          })
          .map((item) => {
            return item.id;
          }),
      })
      .then((res) => {
        setDialog({
          title: "Operación exitosa",
          text: `El rol "${info.nombre.value}" ha sido creado exitosamente.`,
          redirect: true,
          page: "/Roles",
        });
      })
      .catch((err) => {
        if (err.response.status === 500) {
          setDialog({
            title: "ERROR",
            text: "Existe algún problema con el servidor, por favor inténtalo de nuevo mas tarde, si el problema persiste contáctate con alguno de los encargados.",
          });
        } else {
          setDialog({ title: "ERROR", text: err.response.data.message });
        }
      })
      .finally(setOpenDialog(true));
  };

  return (
    <LoaderBox  isLoading={isLoading}>
      <Container
        component="form"
        maxWidth="lg"
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
        onSubmit={handleSubmit}
      >
        <Grid container xs={12} sm={6} spacing={1}>
          <Grid item xs={12}>
            <Typography
              component="h1"
              variant="h5"
              sx={{ display: "flex", justifyContent: "center" }}
              mt={2}
            >
              Nuevo Rol
            </Typography>
            <TextField
              margin="normal"
              required
              fullWidth
              id="nombre"
              label="Nombre"
              name="nombre"
              autoComplete="nombre"
              autoFocus
            />
          </Grid>
          <Grid item xs={12}>
            <MaterialReactTable
              localization={MRT_Localization_ES}
              columns={columns}
              data={items}
              initialState={{
                //showColumnFilters: false,
                density: "compact",
                columnVisibility: { id: false, estado: false },
                pagination: { pageSize: 5 },
              }}
              enableColumnFilterModes={false}
              //enableColumnOrdering={false}
              enableGrouping={false}
              enablePinning={false}
              enableRowActions={false}
              positionToolbarAlertBanner="none"
              enableColumnFilters={false}
              enableDensityToggle={false}
              enableFullScreenToggle={false}
              enableHiding={false}
              enablePagination={true}
              enableTopToolbar={true}
              enableBottomToolbar={true}
            />
          </Grid>
          <Grid item xs={12} sx={{ display: "flex", justifyContent: "center" }}>
            <Button type="submit" variant="contained">
              Guardar
            </Button>
          </Grid>
        </Grid>
      </Container>
      <DialogAlert
        title={dialog.title}
        text={dialog.text}
        open={openDialog}
        setOpen={setOpenDialog}
        redirectOnClose={dialog.redirect}
        page={dialog.page}
        pageState={dialog.pageState}
      />
    </LoaderBox>
  );
}

export { RolAgregar };
